 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import appleEmojis from 'emoji-mart/data/apple.json'
import {uncompress} from 'emoji-mart/dist-modern/utils/data.js'
import {unifiedToNative} from 'emoji-mart/dist-modern/utils/index.js'

uncompress(appleEmojis)

const getReactji = (emoji) => {
  const value = appleEmojis.emojis[emoji ] 
  return {
    unicode: unifiedToNative(value.unified) || '',
    shortName: _nullishCoalesce(value.short_names[0], () => ( ''))
  }
}

export default getReactji
